module.exports = [{
      plugin: require('/Users/florian/Dev/Alqemist/AlqemistWebsite/node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"402710463231210"},
    },{
      plugin: require('/Users/florian/Dev/Alqemist/AlqemistWebsite/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-116536461-1","head":false,"anonymize":true,"respectDNT":true},
    },{
      plugin: require('/Users/florian/Dev/Alqemist/AlqemistWebsite/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
